var $ = jQuery;
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
let mm;
$(document).ready(function ($) {
    if(gsap) {
        gsap.registerPlugin(ScrollTrigger);
        console.log("GSAP and ScrollTrigger are loaded");
    }

    let mm = gsap.matchMedia();
    console.log(mm);
    mm.add("(min-width: 768px)", () => {
        const lastItem = document.querySelector('.blk-timeline .timeline_item_class:last-child');
        const lastItemRect = lastItem.getBoundingClientRect();
        
        const timeline = gsap.timeline({
            scrollTrigger: {
                trigger: ".blk-timeline",
                start: "top top", // When the top of the trigger hits the top of the viewport
                end: () => {
                    // Calculate the dynamic end position based on the last timeline item hitting 50% of the viewport
                    const lastItemRect = lastItem.getBoundingClientRect();
                    return `bottom-=${lastItemRect.height / 2}px center`; 
                  }, // Ends when the last item reaches 50% of the viewport
                scrub: true, // Allows the animation to scrub through as you scroll
                pin: ".blk-timeline .content_class", // Pin the block in place during the scroll
                pinSpacing: false, // Prevent extra spacing when pinned
                // markers: true, // Show markers for debugging
            }
        });
    
        // Show one item at a time using ScrollTrigger for each item
        document.querySelectorAll('.timeline_item_class').forEach((item, index) => {
            gsap.fromTo(item, 
            {
                opacity: 0,
                visibility: 'hidden',
            }, 
            {
                opacity: 1,
                visibility: 'visible',
                duration: 1,
                scrollTrigger: {
                trigger: item,
                start: "top 75%", // Start when the item reaches 75% of the viewport
                end: "bottom 25%", // End when the item reaches 25% of the viewport
                scrub: true,
                onEnter: () => gsap.delayedCall(0.2, () => item.classList.add('show')), // Delay class addition by 0.5 seconds
                onLeaveBack: () => item.classList.remove('show'), // Remove class to hide item
                }
            }
            );
        });
    });


});

$(window).on('resize', function() {
});

$(window).on('click', function() {
});

$(window).on('scroll', function() {
});